import { render, staticRenderFns } from "./ThemeDetail.vue?vue&type=template&id=3945ef45"
import script from "./ThemeDetail.vue?vue&type=script&lang=js"
export * from "./ThemeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports